export default function HeroSection() {
  return (
    <section className="relative w-full h-[500px] md:h-[600px] flex items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Bright%20minimalist%20fashion%20flatlay%20with%20pastel%20tones%2C%20clean%20aesthetic%20product%20photography%2C%20soft%20natural%20lighting%2C%20white%20and%20cream%20background%2C%20elegant%20clothing%20accessories%20and%20shoes%20arranged%20artistically%2C%20high%20detail%2C%20warm%20neutral%20colors%2C%20editorial%20style%2C%20no%20text&width=1600&height=900&seq=yoybuy-hero-01&orientation=landscape"
          alt="YOYBUY Spreadsheet fashion background"
          className="w-full h-full object-cover object-top"
          loading="eager"
          width={1600}
          height={900}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/30 via-black/20 to-black/30" />
      </div>

      <div className="relative z-10 w-full px-4 md:px-8 text-center max-w-4xl mx-auto">
        <p className="text-white/90 text-sm md:text-base font-medium mb-4 tracking-wide uppercase">
          YOYBUY Spreadsheet Guide 2026
        </p>
        <h2 className="text-3xl md:text-5xl font-bold text-white font-heading leading-tight mb-6">
          YOYBUY Spreadsheet — самый выгодный способ покупать в Китае без переплат и посредников
        </h2>
        <p className="text-lg md:text-xl text-white/90 mb-8 max-w-2xl mx-auto leading-relaxed">
          Сравните YOYBUY, KAKOBUY и SUPERBUY Spreadsheet и узнайте, где вы реально экономите до 40% на заказах из Taobao, 1688 и Weidian.
        </p>
        <div className="flex flex-col sm:flex-row items-center justify-center gap-4">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="bg-primary-500 hover:bg-primary-600 text-white font-medium px-8 py-3 rounded-md whitespace-nowrap transition-colors text-center w-full sm:w-auto"
          >
            Начать через YOYBUY Spreadsheet
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="bg-white hover:bg-background-100 text-foreground-950 font-medium px-8 py-3 rounded-md whitespace-nowrap transition-colors text-center w-full sm:w-auto"
          >
            Сравнить YOYBUY / KAKOBUY / SUPERBUY
          </a>
        </div>
      </div>
    </section>
  );
}